<template>
  <div>
    <router-view v-if="maker && maker.id"></router-view>
    <v-row no-gutters justify="center" align="center" class="pt-6 pb-4" v-else>
      <v-progress-linear
        indeterminate
        color= "primary"
        style="max-width: 200px;"
      />
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `SettingsMaker`,
  computed: {
    ...mapState(`ui/settingsMakers`, {
      maker: `currentAdminMaker`,
    }),
  },
  beforeMount() {
    this.$store.commit(`ui/settingsMakers/SET_CURRENT_ADMIN_MAKER`, null);
    this.$store.dispatch(`ui/settingsMakers/fetchCurrentAdminMaker`, this.$route.params.makerId);
  },
};
</script>

<style lang="scss">
</style>
